import React from 'react';
import PropTypes from 'prop-types';
import { AddOrEditPersonForm, Dialog } from 'components/shared';

export const AddPersonModal = ({
  onClose,
  open,
  addPerson,
  updatePerson,
  onSave,
  action,
  onCancel,
  validationErrors,
  currentPerson,
  noPeopleAdded,
}) => {
  const editing = action === 'edit';
  const mainContact =
    currentPerson.mainContact === undefined
      ? noPeopleAdded
      : currentPerson.mainContact;

  return (
    <Dialog
      onClose={onClose}
      id="add-person-dialog"
      open={open}
      maxWidth="lg"
      header={`${editing ? 'Edit' : 'Add'} ${
        mainContact ? 'Main Business Contact for Practice' : 'Person'
      }`}
    >
      <AddOrEditPersonForm
        mode={action}
        initialData={currentPerson}
        validationErrors={validationErrors}
        onAdd={addPerson}
        onEdit={updatePerson}
        onCancel={onCancel}
        saveFormState={onSave}
      />
    </Dialog>
  );
};

AddPersonModal.propTypes = {
  currentPerson: PropTypes.object,
  action: PropTypes.string,
};

AddPersonModal.defaultProps = {
  action: 'add',
  isSolePractitioner: false,
  currentPerson: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    practiceRoles: [],
    vetLicenseNumber: '',
    areaOfInterest: [],
    boardCertifications: [],
    vetSchool: '',
    vetDegree: '',
  },
};
